import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;

const NotificationActions = {
    getNotificationList(params, callback) {
        dispatch({
            type: AppConstants.NOTIFICATION_START_LOADING
        });

        return api.getNotification()
            .then(data => {
                dispatch({
                    type: AppConstants.NOTIFICATION_SUCCESS,
                    item: data.response || {}
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.NOTIFICATION_FAIL,
                        error: err
                    });
                });
            });
    },

    saveViewNotification(params, callback) {
        dispatch({
            type: AppConstants.NOTIFICATION_CLOSE
        });

        return api.saveViewNotification(params)
            .then(data => {
                dispatch({
                    type: AppConstants.NOTIFICATION_CLOSE_SUCCESS
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.NOTIFICATION_FAIL,
                        error: err
                    });
                });
            });
    }
};

export default NotificationActions;
